import { Component, signal } from '@angular/core';

import { FooterConfigItem, HeaderConfig, VbLxp } from '@vbrick/vb-lxp-lib';

@Component({
	selector: 'app-root',
	imports: [VbLxp],
	templateUrl: './app.html',
	styleUrl: './app.css',
})
export class App {
	protected readonly title = signal('vb-lxp-gpx');

	public headerConfig: HeaderConfig = {
		centerImageSrcLight: 'assets/sro-motorsports-group.svg',
		centerImageSrcDark: 'assets/sro-motorsports-group.svg',
		centerImageAlt: 'SRO Logo',
		logoLink: 'https://www.sroamerica.com/',
		logoLinkTarget: '_blank',
	};

	public footerConfig: FooterConfigItem[] = [
		{
			srcLight: 'assets/Vbrick.png',
			srcDark: 'assets/Vbrick.png',
			link: 'https://vbrick.com/live-experience-platform/?utm_source=platform&utm_medium=banner&utm_campaign=sro&utm_content=&utm_term=',
		},
		{ srcLight: 'assets/gpx-light.png', srcDark: 'assets/GPX.png', link: 'https://gpxstream.com' },
		{ srcLight: 'assets/AWS-white.png', srcDark: 'assets/AWS.png', link: 'https://aws.amazon.com' },
	];
}
